<template>
  <div>
    <dx-grid
      :url="url"
      name="recordings"
      :columns="columns"
      title="Recordings"
      ref="grid"
      :beforeSetupGrid="beforeSetupGrid"
    ></dx-grid>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      title: "Credit",
      rowsPerPageItems: [10, 20],
      pagination: {
        totalItems: 0,
        rowsPerPage: 10,
        page: 1,
      },
      url: "",

      isMobile: false,
      selected: [],

      messages: [],

      loading: false,
      viewMessageText: "",
      clickedMessage: "",

      updating: false,
      uploading: false,
      sending: false,
      processing: false,
      awsPolly: "",
      actions: [],
      intervalID: "",

      columns: [
        {
          field: "callerId",
          label: "From Phone",
          format: "",
          visible: true,
          filterType: "",
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          field: "date",
          label: "Date",
          type: "date",
          format: "",
          visible: true,
          filterType: "",
          format: "MM/dd/yyyy hh:mm:ss a",
          sortOrder: "desc",
          sortIndex: 0,
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          field: "recordingURL",
          label: "Recording",
          format: "",
          template: "link-audio-cell-template",
          visible: true,
          filterType: "",
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
        {
          field: "type",
          label: "Type",
          format: "",
          visible: true,
          filterType: "",
          filterValues: [],
          filterValue: null,
          selectedFilterOperation: null,
        },
      ],
    };
  },
  computed: {},
  filters: {
    pretty: function(value) {
      if (!value) return "";

      return JSON.stringify(value, null, 2);
    },
    date: function(value) {
      if (value) {
        return moment(value).format("MM/DD/YYYY h:mm:ss A");
      }
    },
  },
  mounted() {},
  created() {
    //this.loadAccount();
    //this.loadData();
    this.isMobile = window.innerWidth < 551;
  },
  methods: {
    beforeSetupGrid() {
      if (this.$store.state.user == "syw") {
        this.url = "recordings?type=FETER_SHOULYS_MESSAGES";
      } else {
        this.url = "recordings?type=";
      }
    },
  },
};
</script>
<style>
tbody tr:nth-child(even) {
  background-color: #eee;
}
.width-25 {
  width: 25px !important;
  min-width: 25px !important;
  max-width: 25px !important;
}
</style>
